import React, { ReactNode } from "react";
import { useEffect, useState } from "react";
import "../components-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import DropDown from "../UIElements/DropDown";
import { getEstablishmentTypes, getEstablishmentGroups, getRegionByNetworkId } from "../../services";
import { sortAlphabetically } from "../../helpers";
import { SelectChangeEvent } from "@mui/material/Select";
import { isGeneratorFunction } from "util/types";

type EstablishmentCategoryFormWrapperProps = {
    defaultValues: {
        region: string;
        establishmentType: string;
        establishmentGroup: string;
    };
    onSubmit: (data: any) => void;
    formActionComponents: {
        submit: ReactNode;
        cancel?: ReactNode;
    };
    className?: string;
    classes?: any;
    categoryWithName?: boolean;
};

const validationSchema = yup.object({
    region: yup
        .string(),
    establishmentType: yup
        .string()
        .required(`Veuillez choisir un type d'établissement`),
    establishmentGroup: yup
        .string()
        .required("Veuillez choisir un group d'établissement"),
});

export default function EstablishmentCategoryFormWrapper({
    defaultValues,
    onSubmit,
    formActionComponents,
    className,
    classes,
    categoryWithName,
}: EstablishmentCategoryFormWrapperProps) {
    const [establishmentTypeOptions, setEstablishmentTypeOptions] = useState(
        []
    );
    const [establishmentGroupOptions, setEstablishmentGroupOptions] = useState(
        []
    );
    const [networkSelected, setNetworkSelected] = useState(
        0
    );
    const [regions, setRegionsOptions] = useState(
        []
    );

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm({
        defaultValues,
        resolver: yupResolver(validationSchema),
    });
    const [regionInput, setRegionInput] = useState(<></>)
    
    const _onSubmit = (data: any) => {
        if(data.region == "0" || data.region == 0){
            data.region = null;
        }
        if (categoryWithName) {
            const establishmentType = establishmentTypeOptions.find(
                (e: any) => e && e.id + "" === data.establishmentType
            );

            const establishmentGroup = establishmentGroupOptions.find(
                (e: any) => e && e.id + "" === data.establishmentGroup
            );
            onSubmit({ establishmentType, establishmentGroup });
        } else {
            onSubmit(data);
        }
    };

    useEffect(() => {
        (async () => {
            const establishmentTypesRes = await getEstablishmentTypes();
            if (!establishmentTypesRes.detail) {
                setEstablishmentTypeOptions(establishmentTypesRes);
            }
            const establishmentGroupsRes = await getEstablishmentGroups();
            if (!establishmentGroupsRes.detail) {
                setEstablishmentGroupOptions(establishmentGroupsRes);
            }
        })();
    }, []);
    useEffect(() => {
        if(networkSelected == 0)
            return;
        (async () => {
            const regionsRes = await getRegionByNetworkId(networkSelected);
            if(!regionsRes.detail && regionsRes.length > 0) {
                regionsRes.unshift({id: 0, name: "Aucune"})
                setRegionsOptions(regionsRes);
            }
            else{
                setRegionsOptions([]);
            }
        })();
    }, [networkSelected]);

    useEffect(() => {
        if(regions.length > 0)
            setRegionInput(<Controller 
                name="region"
                control={control}
                render={({ field: { ref, ...others } }) => {
                    return (
                        <DropDown
                            items={regions}
                            defaultValue={
                                null
                            }
                            inputlabel={"Région de votre établissement"}
                            {...others}
                            errortext={errors?.region?.message ?? ""}
                            selectpx={classes?.categoryFormElements?.selectpx}
                        />
                    );
                }} />)
        else
            setRegionInput(<></>);
    }, [regions]);

    return (
        <form
            onSubmit={handleSubmit(_onSubmit)}
            className={className ?? "signup-form"}
        >
            <Controller
                name="establishmentType"
                control={control}
                render={({ field: { ref, ...others } }) => {
                    return (
                        <DropDown
                            items={establishmentTypeOptions}
                            defaultValue={
                                defaultValues?.establishmentType ?? ""
                            }
                            inputlabel={"Type d’établissement *"}
                            {...others}
                            errortext={errors?.establishmentType?.message ?? ""}
                            selectpx={classes?.categoryFormElements?.selectpx}
                        />
                    );
                }}
            />
            <Controller
                name="establishmentGroup"
                control={control}
                render={({ field: {onChange, ref, ...others } }) => {
                    return (
                        <DropDown
                            items={sortAlphabetically(
                                establishmentGroupOptions
                            )}
                            defaultValue={
                                defaultValues.establishmentGroup ?? ""
                            }
                            inputlabel={"Réseau *"}
                            onChange={(e: SelectChangeEvent<unknown>, child: ReactNode): void & Function => {
                                onChange(parseInt(`${e.target.value}`));
                                setNetworkSelected(parseInt(`${e.target.value}`));
                            }}
                            {...others}
                           
                            errortext={
                                errors?.establishmentGroup?.message ?? ""
                            }
                            selectpx={classes?.categoryFormElements?.selectpx}
                        />
                    );
                }}
            />
            {regionInput}
            
            {formActionComponents.submit}
            {formActionComponents.cancel}
        </form>
    );
}
